import {ResultatsAlertesComponent} from "./resultats/resultats.alertes.component";
import {ArianeElement, ArianeStore} from "@digicerba/common";
import {Component, ViewChild} from "@angular/core";
import {MessageNotificationSearchCriteria} from "@resources/resources";
import { MessageNotificationSearchCriteriaWithHiglightDto } from "@common/models/message-notification-search-criteria-highlight";

@Component({
  selector: 'consultation-alertes',
  templateUrl: './consultation.alertes.component.html',
  host: {'class': 'page'}
})
export class ConsultationAlertesComponent {

  searchCriteria: MessageNotificationSearchCriteria;
  @ViewChild(ResultatsAlertesComponent) resultats: ResultatsAlertesComponent;
  termsToHighlight: string;

  constructor(arianeStore: ArianeStore) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.HOME",
        route: "/alertes"
      }
    ]
    arianeStore.updateElements(arianeElements);
  }

  onFiltering(criteria: MessageNotificationSearchCriteriaWithHiglightDto): void {
    this.searchCriteria = criteria.messageNotificationSearchCriteria;
    this.termsToHighlight = criteria.termsToHighlight;
  }

  getNombreTotalAlertes() {
    return this.resultats.getNombreTotalAlertes();
  }

  getNombreAlertesNonLues() {
    return this.resultats.getNombreAlertesNonLues();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/consultation/consultation.alertes.component.ts